import { Search } from 'lucide-react';
import { palette, admin, transition, fontFamily } from '../../../styles/tokens';

type Filter = 'all' | 'clients' | 'team';

interface Props {
  query: string;
  onQueryChange: (q: string) => void;
  filter: Filter;
  onFilterChange: (f: Filter) => void;
}

const FILTERS: { key: Filter; label: string }[] = [
  { key: 'all', label: 'All' },
  { key: 'clients', label: 'Clients' },
  { key: 'team', label: 'Team' },
];

export function ConversationSearch({ query, onQueryChange, filter, onFilterChange }: Props) {
  return (
    <div style={{ padding: '12px 16px', borderBottom: `1px solid ${palette.g100}` }}>
      <div style={{
        display: 'flex', alignItems: 'center', gap: 8,
        height: 36, padding: '0 10px', borderRadius: 8,
        background: palette.bg, border: `0.5px solid ${admin.border}`,
      }}>
        <Search size={14} color={palette.g400} />
        <input
          value={query}
          onChange={e => onQueryChange(e.target.value)}
          placeholder="Search conversations..."
          style={{
            flex: 1, border: 'none', background: 'none', outline: 'none',
            fontSize: 13, color: palette.g800, fontFamily,
          }}
        />
      </div>
      <div style={{ display: 'flex', gap: 0, marginTop: 8, background: palette.g100, borderRadius: 6, padding: 2 }}>
        {FILTERS.map(f => (
          <button
            key={f.key}
            onClick={() => onFilterChange(f.key)}
            style={{
              flex: 1, padding: '5px 0', borderRadius: 4, border: 'none',
              fontSize: 11.5, fontWeight: 500, cursor: 'pointer', fontFamily,
              background: filter === f.key ? palette.white : 'transparent',
              color: filter === f.key ? palette.g800 : palette.g500,
              transition: `all ${transition.fast}`,
            }}
          >
            {f.label}
          </button>
        ))}
      </div>
    </div>
  );
}
